import React from "react";
import { Form, Button, Select, Input } from "antd";

import "./Question.scss";
import { ReactSVG } from "react-svg";

const AdminForm = ({ handleSubmitForm, form, handleCancel, adminId }) => {
	return (
		<div className="admin-form-container">
			<Form form={form} onFinish={handleSubmitForm} requiredMark={false}>
				<div className="form-content-group">
					<Form.Item
						label="Email"
						name="email"
						rules={[{ required: true, message: "Required" }]}
					>
						<Input placeholder="Email" />
					</Form.Item>
					<Form.Item
						label="Password"
						name="password"
						rules={!adminId && [{ required: true, message: "Required" }]}
					>
						<Input.Password placeholder="Password" />
					</Form.Item>
					<Form.Item
						label="Role"
						name="role"
						rules={[{ required: true, message: "Required" }]}
					>
						<Select placeholder="Type">
							<Select.Option value="admin">Admin</Select.Option>
							<Select.Option value="super_admin">Super Admin</Select.Option>
							<Select.Option value="shipper">Shipper</Select.Option>
						</Select>
					</Form.Item>
				</div>
				<div className="form-actions">
					<Button type="link" onClick={handleCancel}>
						{" "}
						Cancel{" "}
					</Button>
					<Button type="primary" htmlType="submit" className="btn-primary">
						{adminId ? "Update" : "Create"}
						<ReactSVG src="/icons/check-button.svg" />
					</Button>
				</div>
			</Form>
		</div>
	);
};

export default AdminForm;
